import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { loadSchedules } from './schedules.actions';
import { isPresent } from '@mode/shared/util-js';
import { selectSchedules } from './schedules.selectors';

@Injectable({ providedIn: 'root' })
export class SchedulesFacade {
  schedules$ = this.store.select(selectSchedules).pipe(filter(isPresent));

  constructor(private store: Store) {}

  public loadSchedules(datasetToken: string): void {
    this.store.dispatch(loadSchedules({ datasetToken }));
  }
}
